// customerService.js
import axios from 'axios';

// Helper function to parse XML to JSON
const parseXML = (data) => {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(data, 'text/xml');
  return xmlDoc;
};

// Function to fetch customer details by ID
export const getCustomerById = async (customerId) => {
  try {
    const response = await axios.get(`https://api.simracing.co.uk/v0.1/customers/${customerId}`, {
      headers: {
        Authorization: `SRL ${process.env.REACT_APP_API_KEY}`, // Include API key for authorization
      },
      responseType: 'text', // Specify response type as text for XML response
    });

    const xmlDoc = parseXML(response.data);
    return {
      id: xmlDoc.getElementsByTagName('id')[0]?.textContent,
      name: xmlDoc.getElementsByTagName('name')[0]?.textContent,
      tel: xmlDoc.getElementsByTagName('tel')[0]?.textContent,
      email: xmlDoc.getElementsByTagName('email')[0]?.textContent,
      lapsRecorded: xmlDoc.getElementsByTagName('laps_recorded')[0]?.textContent || 'N/A',
      lastVehicle: xmlDoc.getElementsByTagName('last_vehicle')[0]?.textContent || 'N/A',
      lastCircuit: xmlDoc.getElementsByTagName('last_circuit')[0]?.textContent || 'N/A',
    };
  } catch (error) {
    console.error('Error fetching customer details:', error);
    throw error;
  }
};

// Function to fetch lap times for a customer by ID
export const getCustomerLapTimes = async (customerId) => {
  try {
    const response = await axios.get(`https://api.simracing.co.uk/v0.1/customers/${customerId}/lap_times`, {
      headers: {
        Authorization: `SRL ${process.env.REACT_APP_API_KEY}`, // Include API key for authorization
      },
      responseType: 'text', // Specify response type as text for XML response
    });

    const xmlDoc = parseXML(response.data);
    const resultsArray = Array.from(xmlDoc.getElementsByTagName('result'));

    return resultsArray.map((result) => ({
      circuit_name: result.getElementsByTagName('circuit_name')[0]?.textContent,
      vehicle_name: result.getElementsByTagName('vehicle_name')[0]?.textContent,
      date: result.getElementsByTagName('date')[0]?.textContent,
      lap_time_str: result.getElementsByTagName('lap_time_str')[0]?.textContent,
      telemetry_uri: result.getElementsByTagName('telemetry_uri')[0]?.textContent,
      split1_str: result.getElementsByTagName('split1_str')[0]?.textContent,
      split2_str: result.getElementsByTagName('split2_str')[0]?.textContent,
      split3_str: result.getElementsByTagName('split3_str')[0]?.textContent,
    }));
  } catch (error) {
    console.error('Error fetching customer lap times:', error);
    throw error;
  }
};
